import React, { type FC, type ReactNode } from 'react'
import { useBoxes } from '../hooks/useBoxes'
import { BoxesControllerFindAllParamsOrderByEnum } from '../types/generated'
import type { BoxStatus } from '../api/boxApi'
import { ScrollBoxes } from './ScrollBoxes'
import { createMoneyPoolPagePath } from '../pages/CreateMoneyPoolPage'
import { FormattedMessage } from 'react-intl'

export const AllBoxesScrollBoxes: FC<{
  titleElement: ReactNode | null
  tabsElement: ReactNode
  status: BoxStatus
  lang?: string
  filterType?: 'all' | 'my' | 'my-votes' | 'finished'
}> = ({ titleElement, tabsElement, status, lang, filterType = 'all' }) => {
  const {
    data,
    fetchNextPage,
    isFetching,
    refetch,
    isFetchingNextPage,
    isError,
  } = useBoxes({
    status,
    orderBy: BoxesControllerFindAllParamsOrderByEnum.Deadline,
    lang,
    feedDisplay: true,
    passedModeration: true,
  })

  return (
    <ScrollBoxes
      data={data}
      fetchNextPage={fetchNextPage}
      isFetching={isFetching}
      isFetchingNextPage={isFetchingNextPage}
      isError={isError}
      refetch={refetch}
      titleElement={titleElement}
      tabsElement={tabsElement}
      filterType={filterType}
      emptyNavigateTo={createMoneyPoolPagePath}
      emptyButtonContent={
        <FormattedMessage
          id="empty-list.create-box"
          defaultMessage="Создать бокс"
        />
      }
    />
  )
}
